module.exports = __webpack_public_path__ + "assets/flags/at.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/at.svg
// module id = 494
// module chunks = 0